<template>
    <div id="searchResults" class="search-results-container" :class="{'quick-search': searchType === 'Smart'}">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <searchResultsMenu />
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="content-with-sidebar" >
                    <div class="field-error-message error-large" v-if="serviceError">
                        Unable to load clinical studies data
                        <div class="error-code">
                        {{serviceError}}
                        </div>
                    </div>
                    <div v-if="!clinicalStudyResults && clinicalStudyTable.isLoading" class="loading"><div class="loader-bg"></div><span class="loader">Loading...</span></div>
                    <dataTable class="dataTable" :table="clinicalStudyTable" fromPage="clinicalStudies"  ref="dataTable" v-if="clinicalStudyResults" />
                </div>
            </div>
        </div>

        <!-- Export -->
        <exportModule ref="exportModule"  fromPage="clinicalStudies"/>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';
import Charts from '@/components/global/Charts.vue';
import facets from '@/components/global/facets.vue';
import searchResultsMenu from '@/components/global/searchResultsMenu.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import bus from '@/shared/event-bus.js';

export default {
    name: 'clinicalStudies',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      navigationTabs,
      facets,
      Charts,
      searchResultsMenu,
      exportModule
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'editSearchCriteria',
            'searchMeta',
            'clinicalStudyResults',
            'searchFacetCriteria'
        ]),
    },
    data: function () {
        return {
            serverless: false,
            data: null,
            serviceError: null
        };
    },
    mounted () {
        // console.log(this.$route);
        // check if search ID exists, otherwise redirect to home page
        // if (window.readCookie('searchMode')) {
        //     this.setSearchMode('advanced-search');
        // } else {
        //     this.setSearchMode('');
        // }

        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            if (!this.clinicalStudyResults) {
                this.clinicalStudyTable.isLoading = true;
                if (this.$route.query.sort_field) {
                    this.clinicalStudyTable.sortField = this.$route.query.sort_field;
                }
                if (this.$route.query.sort_order) {
                    this.clinicalStudyTable.sortOrder = this.$route.query.sort_order;
                }
                if (this.$route.query) {
                    this.parseFacetFiltersFromURL();
                }
                this.getClinicalStudies(false);
            } else if (this.clinicalStudyResults.meta.sort_field) {
                this.clinicalStudyTable.sortField = this.clinicalStudyResults.meta.sort_field;
                this.clinicalStudyTable.sortOrder = this.clinicalStudyResults.meta.sort_order;
                let facetToQueryStr = this.$refs.facets.generateQueryString();

                facetToQueryStr['sort_field'] = this.clinicalStudyTable.sortField;
                facetToQueryStr['sort_order'] = this.clinicalStudyTable.sortOrder;
                this.$router.push({ query: facetToQueryStr}).catch(err => {});
            }
        }

        this.setFullscreen(true);
        setTimeout(() => {
            bus.$emit('update:resize');
        }, 1);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode'
        ]),
        setSortDetails ($event, selectedSortColumn) {
            this.clinicalStudyTable.isLoading = true;
            var selectedSortField = this.getFieldNameFromSettings(selectedSortColumn),
                facetToQueryStr;

            if (this.clinicalStudyTable.sortField === selectedSortField) {
                this.clinicalStudyTable.sortOrder = (this.clinicalStudyTable.sortOrder === 'asc' ? 'desc' : 'asc');
            } else {
                this.clinicalStudyTable.sortOrder = selectedSortColumn.sortOrder;
            }
            this.clinicalStudyTable.sortField = selectedSortField;
            this.clinicalStudyTable.offset = 0;
            window.scrollTo(0, 0);

            facetToQueryStr = this.$refs.facets.generateQueryString();
            facetToQueryStr['sort_field'] = this.clinicalStudyTable.sortField;
            facetToQueryStr['sort_order'] = this.clinicalStudyTable.sortOrder;

            this.$router.push({ query: facetToQueryStr});
			gtag('event','Click', {
				'event_category': 'Clinical Study Results',
				'event_label': 'Clinical Study Results - sorted on ' + this.clinicalStudyTable.sortField + ' (' + this.clinicalStudyTable.sortOrder + ')',
				'value': 'Clinical Study Results - sorted on ' + this.clinicalStudyTable.sortField + ' (' + this.clinicalStudyTable.sortOrder + ')'
			});	
            this.getClinicalStudies(false);
        },
        setProjectPageNumber (requestedPage) {
            if (requestedPage === this.$options.name) {
                if (this.$store.state.clinicalStudyResults && this.$store.state.clinicalStudyResults.meta.total > this.clinicalStudyTable.offset + this.clinicalStudyTable.limit) {
                    this.clinicalStudyTable.loadingMoreData = true;
                    this.clinicalStudyTable.offset += this.clinicalStudyTable.limit;
                    this.getClinicalStudies(false);
                }
            }
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam = {
                "search_id": this.$route.params.search_id,
                "facet_filters": this.searchFacetCriteria,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "offset": 0,
                "limit": 0,
                "sort_field": this.clinicalStudyTable.sortField,
                "sort_order": this.clinicalStudyTable.sortOrder
            }
            if (this.clinicalStudyResults.meta.properties && this.clinicalStudyResults.meta.properties.CacheId) {
                searchParam['cache_id'] = this.clinicalStudyResults.meta.properties.CacheId;
            }
            this.getExportFile(searchParam, callback);
        },
        scrollToResultsTop () {
            let resultsOffsetTop = this.getResultsContainerOffsetTop();

            // only scroll up if user view is scrolled below top of table
            if (window.pageYOffset > resultsOffsetTop) {
                window.scrollTo(0, this.getResultsContainerOffsetTop());
            }
        },
        getResultsContainerOffsetTop () {
            return this.$refs.resultsContainer ? this.$refs.resultsContainer.offsetTop : 0;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

</style>